import { briefings } from "@/mocks/home";
import SectionHead from "./SectionHead";

export default function NewsFlash() {
  return (
    <section id="flash" className="scroll-mt-24 border-y border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <SectionHead
          kicker="FOLLOWING"
          title="今日快讯"
          sub="按时间倒序整理今日重点动向，短平快一条读懂当天进展。"
          more
          anchor="#stream"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {briefings.map((b) => (
            <a
              key={b.title}
              href="#stream"
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
            >
              <div className="mb-3 flex items-center justify-between">
                <span className="font-mono text-lg font-bold tabular-nums text-primary-600">{b.time}</span>
                <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">{b.tag}</span>
              </div>
              <h3 className="clamp-3 font-heading text-sm font-bold leading-relaxed text-foreground-900 group-hover:text-primary-700 md:text-base">
                {b.title}
              </h3>
              <div className="mt-3 flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-eye-line" />
                {b.views} 关注
                <span className="ml-auto flex h-2 w-2 items-center justify-center">
                  <i className="ri-arrow-right-up-line opacity-0 transition-opacity group-hover:opacity-100" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}